import React from 'react';

/**
 * Section utilisateur en bas de la sidebar
 * Affiche avatar, nom, rôle et bouton déconnexion
 */
const SidebarUserInfo = ({ user, isCollapsed, onLogout }) => {
  if (!user) return null;

  // Obtenir les initiales de l'utilisateur
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Traduire le rôle en français
  const getRoleLabel = (role) => {
    const roleLabels = {
      'Admin': 'Administrateur',
      'Planificateur': 'Planificateur',
      'RH': 'Ressources Humaines',
      'Administrative': 'Administratif',
      'Employés': 'Employé',
      'Comptabilité': 'Comptabilité',
      'Chef d\'équipe': 'Chef d\'équipe'
    };
    return roleLabels[role] || role;
  };

  return (
    <div className="sidebar-user">
      <div className="sidebar-user-info">
        <div className="sidebar-user-avatar" title={user.name}>
          {getInitials(user.name)}
        </div>
        <div className="sidebar-user-details">
          <div className="sidebar-user-name" title={user.name}>
            {user.name}
          </div>
          <div className="sidebar-user-role">
            {getRoleLabel(user.role)}
          </div>
        </div>
      </div>
      <button
        className="sidebar-logout"
        onClick={onLogout}
        aria-label="Se déconnecter"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        <span>Déconnexion</span>
      </button>
    </div>
  );
};

export default React.memo(SidebarUserInfo);
